/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import Box from '../Grid/Box';
import Text from '../Text/Text';

/**
 * A text spanning multiple lines.
 * @param {object} props
 * @param {string} props.text The text to split into multiple lines.
 * @param {import('../Text/textVariants').TextVariants} [props.variant]
 */
export default function MultilineText({ text, variant, ...rest }) {
  if (!text) return null;
  return (
    <Box {...rest}>
      {text.split('\n').map((line, index) => (
        <Text key={index} variant={variant}>
          {line}
        </Text>
      ))}
    </Box>
  );
}
